import constants from './constants';

enum ACTION_NAME_TYPES {
	releaseActions = 'releaseactions',
	clickActions = 'clickactions',
	rolloverActions = 'rolloveractions',
	rolloffActions = 'rolloffactions',
}

enum ACTION_VALUE_TYPES {
	goToDestination = 'goToDestination',
}

const ACTION_NAMES = {
	releaseActions: ACTION_NAME_TYPES.releaseActions,
	clickActions: ACTION_NAME_TYPES.clickActions,
	rolloverActions: ACTION_NAME_TYPES.rolloverActions,
	rolloffActions: ACTION_NAME_TYPES.rolloffActions,
};

const actionsToDisable = [
	ACTION_VALUE_TYPES.goToDestination,
];

const hasAction = (actionNames: ACTION_NAME_TYPES[]): boolean => (
	actionNames.some(actionName => actionName.includes('action'))
);

const isDisabledAction = (actionValues: ACTION_VALUE_TYPES[]): boolean => (
	actionValues.some(actionValue => (
		actionsToDisable.some(actionToDisable => (
		  actionValue.includes(actionToDisable)
		))
	))
);

const hasReleaseOrClickAction = (actionNames: ACTION_NAME_TYPES[]): boolean => (
	actionNames.some(actionName => (
		[
			ACTION_NAME_TYPES.releaseActions,
			ACTION_NAME_TYPES.clickActions,
		].includes(actionName)
	))
);

const setTriggerActions = (button: HTMLButtonElement, trigger: HTMLButtonElement, actionNames: ACTION_NAME_TYPES[]): void => {
	const { dataset: {
		releaseactions,
		clickactions,
		rolloveractions,
		rolloffactions,
	} } = button;

	// tslint:disable-next-line: max-line-length
	// We have to change rollover or rolloff actions (hover) to release actions (click) to allow editing texts and images in hidden blocks which are appeared by rollover/rolloff in inDesign
	const action = hasReleaseOrClickAction(actionNames)
		? releaseactions || clickactions
		: rolloveractions || rolloffactions;

	trigger.setAttribute('data-releaseactions', action as string);

	// tslint:disable-next-line: max-line-length
	// We have to remove all actions from button to not change state of slide (e. g., change state of Multi State Object from inDesign) when click on text or image inside button. Click action is handled by trigger
	Object.values(ACTION_NAMES).forEach((actionName) => {
		button.removeAttribute(`data-${actionName}`);
	});
};

const addTriggerToButton = (htmlDocument: HTMLDocument, button: HTMLButtonElement, actionNames: ACTION_NAME_TYPES[]): void => {
	const trigger = htmlDocument.createElement('button');
	trigger.type = 'button';
	trigger.className = `${constants.buttonClassName} editor-btn-trigger`;
	setTriggerActions(button, trigger, actionNames);
	button.appendChild(trigger);
};

// tslint:disable-next-line: max-line-length
// We have to add special trigger to button to allow selection of editable texts and images in case button overlaps text or image. Buttons with special actions shouldn't have triggers (they are disabled in css via pointer-events: none)
const addTriggersToButtons = (htmlDocument: HTMLDocument): HTMLDocument => {
	const buttons = [
		...htmlDocument.querySelectorAll(`[class*=${constants.buttonClassName}]`),
	] as HTMLButtonElement[];

	buttons.forEach((button) => {
		const actionNames = Object.keys(button.dataset) as ACTION_NAME_TYPES[];
		const actionValues = Object.values(button.dataset) as ACTION_VALUE_TYPES[];

		if (!hasAction(actionNames) || isDisabledAction(actionValues)) {
			return;
		}

		addTriggerToButton(htmlDocument, button, actionNames);
	});

	return htmlDocument;
};

export default addTriggersToButtons;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/buttons.ts